const fetchPolyfill = require('whatwg-fetch')
const passwordHasher = require('./passwordHasher')

const onResponse = (response, hashSuffix, resolve, reject) => {
    response.text()
            .then(t => {
                    const matches = t.split("\n")
                                     .map(l => l.trim())
                                     .map(l => l.split(":"))
                                     .map(parts => ({
                                         hashSuffix: parts[0],
                                         count: parts[1]
                                     }))
                                     .filter(ps => ps.hashSuffix === hashSuffix)

                    resolve({
                        found: matches.length > 0,
                        count: (matches[0] || { count: 0 }).count
                    })
                }
            )
            .catch(reject)
}

/*
use crypto module
hash the password
send the first 5 characters to https://api.pwnedpasswords.com/range/
get back hashes and number of incidences
try find password hash in the result
warn user if found
*/
module.exports = {
    check: password => {
        const hash = passwordHasher.hash(password)

        return new Promise((resolve, reject) => {

            fetchPolyfill.fetch(`https://api.pwnedpasswords.com/range/${hash.prefix}`)
                         .then(r => onResponse(r, hash.suffix, resolve, reject))
                         .catch(reject)
        })
    }
}